import React, { useEffect, useState } from "react";
import "./Vision_Mission_Value.css";
import { VisionMissions } from "../../../utils/apis/aboutus/Aboutus.js";
import { IDS } from "../../../utils/common";
import Common_heading from "../../common/common_heading/Common_heading.js";

const Vision_Mission_Value = () => {
  const [vmvData, setVmvData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fallback map icons if database paths are broken/empty
  const iconFallbacks = {
    vision: "🎯",
    mission: "🚀",
    value: "💎"
  };

  useEffect(() => {
    const fetchDynamicData = async () => {
      try {
        setLoading(true);
        const res = await VisionMissions();
        if (res?.success && Array.isArray(res?.data)) {
          setVmvData(res.data);
        }
      } catch (error) {
        console.error("Frontend Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDynamicData();
  }, []);

  return (
    <section className="vision_mission_section">
      <div className="container">
        
        <Common_heading 
          title="Driving Secure Innovation and Trust" 
          subtitle="We combine managed IT expertise, robust cloud infrastructure, and advanced cybersecurity to deliver resilient digital frameworks your business can rely on." 
        />

        {loading ? (
          <div className="vmv_loading_container">
            <div className="spinner"></div>
            <p>Loading core parameters...</p>
          </div>
        ) : (
          <div className="cards_grid_wrapper">
            {vmvData.map((item) => {
              // Extract unique identifiers normalized for fallback selectors
              const keySlug = item.slug?.toLowerCase() || "vision";

              return (
                <div className="vmv_card" key={item._id || item.id}>
                  {/* Card Banner Image Block */}
                  <div className="card_image_box">
                    {item.image ? (
                      <img 
                        src={`${IDS?.IMG_URL}${item.image}`} 
                        alt={item.name} 
                        onError={(e) => { 
                          // If remote image path fails, replace it visually with text icon
                          e.target.style.display = 'none';
                          e.target.parentNode.innerHTML = `<div class="fallback_icon">${iconFallbacks[keySlug] || "🌐"}</div>`;
                        }} 
                      />
                    ) : (
                      <div className="fallback_icon">{iconFallbacks[keySlug] || "🌐"}</div>
                    )}
                  </div>

                  {/* Card Information Body */}
                  <div className="card_content">
                    <h3>{item.name}</h3>
                    {/* Securely handle rich text inputs from database editors */}
                    <p dangerouslySetInnerHTML={{ __html: item.description || "" }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}

      </div>
    </section>
  );
};

export default Vision_Mission_Value;